import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm.js'
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js'
import LazyLoad from 'vanilla-lazyload'
window.lazyLoad = new LazyLoad({
    elements_selector: '[data-src], [data-srcset], [data-bg]'
})

function toggleOnClick(clickSelector, targetSelector, toggleClass) {
    document.querySelectorAll(clickSelector).forEach((el) => {
        el.addEventListener('click', (e) => {
            if (targetSelector == null) {
                el.classList.toggle(toggleClass)
            } else {
                var sel = targetSelector //yes it needs a separate variable
                if (el.dataset.key) sel += `[data-key="${el.dataset.key}"]`
                document.querySelectorAll(sel).forEach((tEl) => {
                    tEl.classList.toggle(toggleClass)
                })
            }
        })
    })
}

function initPhotoswipe(el) {
    const lightbox = new PhotoSwipeLightbox({
        gallery: el,
        children: '.gallery__cell',
        pswpModule: PhotoSwipe,
        tapAction: 'zoom',
        bgOpacity: 0.95
    })
    lightbox.init()
}

document.querySelectorAll('.gallery__grid').forEach(function (el) {
    initPhotoswipe(el)
})

document.querySelectorAll('.header__lang-select').forEach(function (el) {
    el.addEventListener('change', (e) => {
        window.location.href = e.target.value
    })
})

window.createMap = () => {
    document.querySelectorAll('.gmap').forEach(el => {
        el.style.minHeight = '450px'
        if (document.head.querySelector('#gmaps') == null) {
            var s = document.createElement('script')
            s.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyDnhp7dSD9Cg5l704fTM0pzLswVAgf6EnY&callback=createMap'
            s.id = 'gmaps'
            document.head.appendChild(s)
        } else {
            var lat = parseFloat(el.dataset.lat)
            var lon = parseFloat(el.dataset.lon)
            var latlng = { lat: lat, lng: lon }
            var options = {
                zoom: 15,
                center: latlng,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.RIGHT_BOTTOM
                },
                panControlOptions: {
                    position: google.maps.ControlPosition.LEFT_TOP
                }

            }
            var map = new google.maps.Map(el, options)
            var marker = new google.maps.Marker({
                position: latlng,
                map: map,
            })
        }
    })
}

let pp = document.getElementById('printpage')
if (pp) {
    pp.addEventListener('click', (e) => {
        window.print()
    })
}

(function () {
    document.querySelectorAll('.js-burger').forEach(el => {
        el.addEventListener('click', (e) => {
            el.classList.toggle('is-active')
            document.querySelector('.js-mobilenav').classList.toggle('is-active')
            document.documentElement.classList.toggle('is-scroll-lock')
        })
    })

    createMap()

    toggleOnClick('.js-login-btn', '.js-auth', 'is-active')
    toggleOnClick('.js-close-btn', '.js-auth', 'is-active')
    toggleOnClick('.accordion__head', '.accordion__item', 'is-active')
    toggleOnClick('.mobilenav__item.has-dropdown', null, 'is-active')

})()